import { render, staticRenderFns } from "./rankList.vue?vue&type=template&id=35979d0a&"
import script from "./rankList.vue?vue&type=script&lang=js&"
export * from "./rankList.vue?vue&type=script&lang=js&"
import style0 from "./rankList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports